import { render, staticRenderFns } from "./Tax.vue?vue&type=template&id=509f5d39&"
import script from "./Tax.vue?vue&type=script&lang=ts&"
export * from "./Tax.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('509f5d39')) {
      api.createRecord('509f5d39', component.options)
    } else {
      api.reload('509f5d39', component.options)
    }
    module.hot.accept("./Tax.vue?vue&type=template&id=509f5d39&", function () {
      api.rerender('509f5d39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/Tax.vue"
export default component.exports